export default "__VITE_ASSET__X8xvJRKm__"